// extracted by mini-css-extract-plugin
module.exports = {"noteActivitySelect":"AnnotationActivityTab_noteActivitySelect__qvYmp","editor":"AnnotationActivityTab_editor__3OZ5u","editorIcon":"AnnotationActivityTab_editorIcon__e23CM"};